import type { FetchArgs } from '@reduxjs/toolkit/query';
import {
  ORGS_BASE_PATH,
  ORG_TIERS_BASE_PATH,
  type CreateOrgPayload,
  type OrgAccountMetricsParams,
  type UpdateOrgArg,
  type UpdateOrgMembersArg,
  type UpdateOrgTierArg,
} from './adminOrgs.types';

export function getOrgsQueryDefinition(): string {
  return ORGS_BASE_PATH;
}

export function getOrgQueryDefinition(id: number): string {
  return `${ORGS_BASE_PATH}/${encodeURIComponent(id)}`;
}

export function updateOrgMutationDefinition(arg: UpdateOrgArg): FetchArgs {
  return {
    url: `${ORGS_BASE_PATH}/${encodeURIComponent(arg.id)}`,
    method: 'PUT',
    body: arg.body,
  };
}

export function activateOrgMutationDefinition(id: number): FetchArgs {
  return {
    url: `${ORGS_BASE_PATH}/${encodeURIComponent(id)}/activate`,
    method: 'PUT',
  };
}

export function deactivateOrgMutationDefinition(id: number): FetchArgs {
  return {
    url: `${ORGS_BASE_PATH}/${encodeURIComponent(id)}/deactivate`,
    method: 'PUT',
  };
}

export function getOrgTiersQueryDefinition(): string {
  return ORG_TIERS_BASE_PATH;
}

export function updateOrgTierMutationDefinition(arg: UpdateOrgTierArg): FetchArgs {
  return {
    url: `${ORG_TIERS_BASE_PATH}/${encodeURIComponent(arg.id)}`,
    method: 'PUT',
    body: arg.body,
  };
}

export function getOrgMembersQueryDefinition(orgId: number): string {
  return `${ORGS_BASE_PATH}/${encodeURIComponent(orgId)}/members`;
}

export function getOrgAccountSummaryQueryDefinition(orgId: number): string {
  return `${ORGS_BASE_PATH}/${encodeURIComponent(orgId)}/account_summary`;
}

export function updateOrgMembersMutationDefinition(arg: UpdateOrgMembersArg): FetchArgs {
  return {
    url: `${ORGS_BASE_PATH}/${encodeURIComponent(arg.orgId)}/members`,
    method: 'PUT',
    body: { members: arg.members },
  };
}

export function activateOrgMembersMutationDefinition(arg: UpdateOrgMembersArg): FetchArgs {
  return {
    url: `${ORGS_BASE_PATH}/${encodeURIComponent(arg.orgId)}/members/activate`,
    method: 'PUT',
    body: { members: arg.members },
  };
}

export function deactivateOrgMembersMutationDefinition(arg: UpdateOrgMembersArg): FetchArgs {
  return {
    url: `${ORGS_BASE_PATH}/${encodeURIComponent(arg.orgId)}/members/deactivate`,
    method: 'PUT',
    body: { members: arg.members },
  };
}

export function createOrgMutationDefinition(body: CreateOrgPayload): FetchArgs {
  return {
    url: ORGS_BASE_PATH,
    method: 'POST',
    body,
  };
}

export function getOrgAccountMetricsQueryDefinition(params: OrgAccountMetricsParams): FetchArgs {
  const { orgId, from, to } = params;
  const query = new URLSearchParams();
  if (from) query.set('from', from);
  if (to) query.set('to', to);
  const qs = query.toString();
  return {
    url: `${ORGS_BASE_PATH}/${encodeURIComponent(orgId)}/flows/account_metrics${qs ? `?${qs}` : ''}`,
  };
}
